__turbopack_context__.v({
  "blocksBackgroundColor": "ShopBlock-module-scss-module__ITMr5G__blocksBackgroundColor",
  "blocksFontColor": "ShopBlock-module-scss-module__ITMr5G__blocksFontColor",
  "contactInfo": "ShopBlock-module-scss-module__ITMr5G__contactInfo",
  "container": "ShopBlock-module-scss-module__ITMr5G__container",
  "infoMessage": "ShopBlock-module-scss-module__ITMr5G__infoMessage",
  "item": "ShopBlock-module-scss-module__ITMr5G__item",
  "loadingClassName": "ShopBlock-module-scss-module__ITMr5G__loadingClassName",
  "loadingIndicator": "ShopBlock-module-scss-module__ITMr5G__loadingIndicator",
  "secondaryNavBackgroundColor": "ShopBlock-module-scss-module__ITMr5G__secondaryNavBackgroundColor",
  "themeBackgroundColor": "ShopBlock-module-scss-module__ITMr5G__themeBackgroundColor",
  "themeFontColor": "ShopBlock-module-scss-module__ITMr5G__themeFontColor",
  "themeFontFamily": "ShopBlock-module-scss-module__ITMr5G__themeFontFamily",
});
